import { CreateIconArguments } from '##/icons/Icon/helpers';

import IconFractureBlueSizeS from './IconFractureBlue_size_s';

const props: CreateIconArguments = {
  l: IconFractureBlueSizeS,
  m: IconFractureBlueSizeS,
  s: IconFractureBlueSizeS,
  xs: IconFractureBlueSizeS,
  name: 'IconFractureBlue',
  renderType: { l: 'use', m: 'use', s: 'use', xs: 'use' },
  color: 'multiple',
};

export default props;
